import { render, staticRenderFns } from "./OfficesDriversDetail.vue?vue&type=template&id=1ac81dfa&"
import script from "./OfficesDriversDetail.vue?vue&type=script&lang=js&"
export * from "./OfficesDriversDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports